import { render, staticRenderFns } from "./ListPlans.vue?vue&type=template&id=d55badb8&"
import script from "./ListPlans.vue?vue&type=script&lang=ts&"
export * from "./ListPlans.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports